import { buildHeaders } from "./helpers/headerHelper";
import type { APIResultNoContent } from "./types";

export async function createInvite(email: string): Promise<APIResultNoContent> {
  try {
    const normalizedEmail = email.trim();

    if (!normalizedEmail) {
      return {
        success: false,
        errorMsg: "Email is required",
      };
    }

    const headers = buildHeaders();

    void headers;

    const response = await new Promise((resolve) => setTimeout(resolve, 1000));

    if (!response) {
      throw new Error("something went wrong");
    }

    return {
      success: true,
    };
  } catch (error) {
    return {
      success: false,
      errorMsg:
        error instanceof Error ? error.message : "an unknown error occurred",
    };
  }
}
